import React from "react";

function Pagination({ currentPage, totalPages, onPageChange }) {
	function getPages(current, total) {
		const pages = [];

		if (total <= 5) {
			for (let i = 1; i <= total; i++) {
				pages.push(i);
			}
		} else {
			pages.push(1);

			if (current > 3) {
				pages.push("...");
			}

			const start = Math.max(2, current - 1);
			const end = Math.min(total - 1, current + 1);

			for (let i = start; i <= end; i++) {
				pages.push(i);
			}

			if (end < total - 1) {
				pages.push("...");
			}

			pages.push(total);
		}

		return pages;
	}

	const pagesToShow = getPages(currentPage, totalPages);

	return (
		<div className="pagination">
			<button
				className="btn btn--prev"
				onClick={() => onPageChange(currentPage - 1)}
				disabled={currentPage === 1}
			>
				&lt;
			</button>

			{pagesToShow.map((item, idx) => {
				if (item === "...") {
					return (
						<span key={`ellipsis-${idx}`} className="ellipsis">
							...
						</span>
					);
				} else {
					const page = item;
					const isActive = page === currentPage;
					return (
						<button
							key={page}
							className={`btn btn--page ${
								isActive ? "active" : ""
							}`}
							onClick={() => onPageChange(page)}
						>
							{page}
						</button>
					);
				}
			})}

			<button
				className="btn btn--next"
				onClick={() => onPageChange(currentPage + 1)}
				disabled={currentPage === totalPages || totalPages === 0}
			>
				&gt;
			</button>
		</div>
	);
}

export default Pagination;
